import { z } from 'zod';
export const spentBreakdownItemSchema = z.object({
    currency: z.string(),
    total: z.number(),
});
export const dashboardFinanceSchema = z.object({
    spentTotal: z.number(),
    spentMonth: z.number(),
    planned14d: z.number(),
    budgetTotal: z.number().nullable(),
    budgetLeft: z.number().nullable(),
    expenseCount: z.number().default(0),
    /** Черновики: запланированные, но ещё не оплаченные траты (status = DRAFT). */
    draftsTotal: z.number().default(0),
    draftsCount: z.number().default(0),
    spentBreakdown: z.array(spentBreakdownItemSchema).optional(),
});
export const dashboardStageSchema = z.object({
    current: z.object({
        id: z.string(),
        title: z.string(),
        status: z.string(),
        progress: z.number(),
    }).nullable(),
    next: z.object({
        id: z.string(),
        title: z.string(),
    }).nullable(),
    inProgress: z.array(z.object({
        id: z.string(),
        title: z.string(),
        progress: z.number(),
    })).default([]),
});
export const dashboardMaterialsSchema = z.object({
    total: z.number(),
});
export const dashboardSchema = z.object({
    finance: dashboardFinanceSchema,
    stage: dashboardStageSchema,
    materials: dashboardMaterialsSchema.optional(),
});
//# sourceMappingURL=dashboard.js.map